import RestApi from './api'
import config from './config'
import fn from './fn'
import routes from './routes'
import stores from './stores'

export default {
  api: {
    RestApi,
  },
  config,
  fn,
  routes,
  stores,
}
